import { Online } from 'libraries/front-end-core/services/WindowService'
import { Api } from 'libraries/front-end-core/core/Api'
import {
  CurrentAwareness,
  CurrentAwarenessPrepay,
  CurrentAwarenessArticle,
  CurrentAwarenessSearch,
  CurrentAwarenessSearchPrepay,
  Guides,
  FeaturedGuides,
  PublishedCaKeyPicks,
  HomePageArticles,
  HomePageArticleSingle,
  HomePageArticleSinglePrepay,
  PublishedCaKeyPicksPrepay
} from 'requests/ca'
import {
  LegislationAct,
  LegislationActs,
  LegislationFolders,
  LegislationReference,
  LegislationRelatedQas,
  LegislationSearch,
  LegislationSearchPrepay,
  TakeoverCode,
  TakeoverCodeVersions
} from 'requests/legislation'
import {
  CaseRefsChapter,
  QAContent,
  QAContentPrepay,
  QAInstantSearch,
  QAReferences,
  QASearch,
  QASearchPrepay,
  QASections,
  QASectionsPrepay
} from 'requests/qa'
import {
  User,
  UserAuth,
  SearchHistory,
  Tracking,
  EmailPreferences,
  AolOrderPreferences,
  PrimaryAolPreference,
  PractisingAolPreference
} from 'requests/session'
import {
  EventTypes,
  FeaturedDeal,
  StatsSummary,
  LatestDeals,
  EventConfiguration,
  SharedEventsConfiguration,
  ListDeals,
  Stats,
  Deal
} from 'requests/dealwatch'
import {
  DocumentSections,
  Documents,
  DocumentsPrepay,
  AutomatedDocuments,
  AutomatedDocumentsPrepay,
  ClarilisDocuments,
  DocumentsSearch,
  DocumentsSearchPrepay
} from 'requests/document'
import {
  Favourites
} from 'requests/favourites'
import fcObserveRequest from 'helpers/fcObserveRequest'

/* eslint-disable */
const ApiStorage = new Api([
  CurrentAwareness,
  CurrentAwarenessPrepay,
  CurrentAwarenessArticle,
  CurrentAwarenessSearch,
  CurrentAwarenessSearchPrepay,
  Guides,
  FeaturedGuides,
  PublishedCaKeyPicks,
  PublishedCaKeyPicksPrepay,
  HomePageArticles,
  HomePageArticleSingle,
  HomePageArticleSinglePrepay,
  LegislationAct,
  LegislationActs,
  LegislationFolders,
  LegislationReference,
  LegislationRelatedQas,
  LegislationSearch,
  LegislationSearchPrepay,
  TakeoverCode,
  TakeoverCodeVersions,
  CaseRefsChapter,
  QAContent,
  QAContentPrepay,
  QAInstantSearch,
  QAReferences,
  QASearch,
  QASearchPrepay,
  QASections,
  QASectionsPrepay,
  User,
  UserAuth,
  SearchHistory,
  Tracking,
  EventTypes,
  FeaturedDeal,
  StatsSummary,
  LatestDeals,
  EventConfiguration,
  SharedEventsConfiguration,
  ListDeals,
  Stats,
  Deal,
  DocumentSections,
  Documents,
  DocumentsPrepay,
  AutomatedDocuments,
  AutomatedDocumentsPrepay,
  ClarilisDocuments,
  DocumentsSearch,
  DocumentsSearchPrepay,
  EmailPreferences,
  Favourites,
  AolOrderPreferences,
  PrimaryAolPreference,
  PractisingAolPreference
], { Online, observeRequest: fcObserveRequest })
/* eslint-enable */

export const fetch = ApiStorage.fetch
export const refresh = ApiStorage.refresh
export const observe = ApiStorage.observe
